<template>
  <DBox
    :id="'cmp-royalty-royalty_accounts-accounting_setup'"
    :addButton="false"
    :addLink="false"
  >
    <Dropdown2
       deselect
      :label="$t('vat')"
      :placeholder="$t('vat')"
      :options="vatTypesTV"
      :selected="
        vatTypesTV.find(
          (e) => e.value == selectedAccountDetails.royalty_account.vat_type
        )
      "
      :lw="'135px'"
      v-on:selectedChange="(e) => onDropdownChange('vat_type', e)"
    />

    <Dropdown2
       deselect
      :label="$t('tax_other')"
      :placeholder="$t('tax_other')"
      :options="selectedAccountDetails.tax_groupsTV"
      :selected="
        selectedAccountDetails.tax_groupsTV.find(
          (e) =>
            e.value ==
            selectedAccountDetails.royalty_account.tax_type_id_deduction
        )
      "
      :hint="$t('tax_group_info')"
      :lw="'135px'"
      v-on:selectedChange="(e) => onDropdownChange('tax_type_id_deduction', e)"
    />
    <TextField2
      :id="'due_days'"
      :placeholder="$t('due_days')"
      :label="$t('due_days')"
      :value="selectedAccountDetails.royalty_account.due_days"
      :lw="'135px'"
      @blur="onTextFieldValueChange"
    />
    <div style="border-bottom: none; min-width:135px;" class="fc2 fc2-row ut-flex">
      <label style="min-width:135px" class="fc2-label txtov">{{
        $dft.snakeCaseToWords("No Vat on RR")
      }}</label>

      <div class="ut-flex">
        <div class="dt-checkbox v2 s1">
          <input
            type="checkbox"
            @click="(e) => onCheckboxChange('reserves_no_vat', e)"
            :name="'reserves_no_vat'"
            :id="'reserves_no_vat'"
            :checked="selectedAccountDetails.royalty_account.reserves_no_vat"
          />
          <div class="checkmark"></div>
        </div>
      </div>
    </div>
  </DBox>
</template>

<script>
export default {
  props: ["selectedAccountDetails"],

  computed: {
    accountSetup: function () {
      return this.selectedAccountDetails.account_setup || {};
    },
    vatTypesTV:function(){
      const invoice_project = this.selectedAccountDetails?.invoice_project||{}
      let vat_typesTV = [...this.selectedAccountDetails.vat_typesTV]
      return [ {text:this.$t('no_VAT') ,value:'0'},...vat_typesTV]
    }
  },
  watch: {},

  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      console.log("name", name, value.value);
      const data=value.value?value.value:""
      this.$emit("changed", { name, value: data });
    },
    onCheckboxChange: function (name, value) {
      value = value.target.checked ? "1" : "0";
      this[name] = value;
      this.$emit("changed", { name, value });
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-royalty-royalty_accounts-accounting_setup {
  .form-group .input_box {
    padding: 0px 5px;
  }
  .form-group .check_box {
    padding-top: 4px;
  }
  .fc2-row {
    --bb: 1px solid var(--sprt-85);
    // height: 30px;
    border-bottom: var(--bb);

    .fc2-label,
    .icon,
    .title {
      flex: 1;
    }
    .fc2-label,
    .title-txt {
      max-width: 115px;
    }
    > .ut-flex {
      margin-left: 12px !important;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;
    }
  }
}
</style>